import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-interaction-popup',
  templateUrl: './interaction-popup.component.html',
  styleUrls: ['./interaction-popup.component.scss'],
})
export class InteractionPopupComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  close() {
    this.activeModal.close();
  }
}
